import React, { useState, useEffect, useMemo, useRef } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import AttendanceBookStatementFilter from "./AttendanceBookStatementFilter";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";

const AttendanceBookStatementComponent = ({
  data,
  selectedResource,
  selectAllChecked,
  columns,
  isSrNoRequired,
  handleReset,
  isApiStatus,
  isRequiredStatus,
  searchTerm,
  setSearchTerm,
  handleColumnSelect,
  handleTextChange,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  console.log("columns", columns);
  const [visibleColumns, setVisibleColumns] = useState(
    Object.keys(columns).reduce((acc, key) => {
      acc[key] = columns[key].visible; // Set initial visibility based on the 'visible' key
      return acc;
    }, {})
  );
  const [editingIndex, setEditingIndex] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName], // Toggle visibility
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  console.log("data------>", data);

  const sortedData = useMemo(() => {
    if (!Array.isArray(data) || !sortConfig) return data || [];

    const { key, direction } = sortConfig;

    return [...data].sort((a, b) => {
      const valA = a[key] ? String(a[key]) : "";
      const valB = b[key] ? String(b[key]) : "";

      const partsA = valA.match(/(\D+|\d+)/g) || [];
      const partsB = valB.match(/(\D+|\d+)/g) || [];

      for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
        const partA = partsA[i] || "";
        const partB = partsB[i] || "";

        const isNumericA = !isNaN(partA);
        const isNumericB = !isNaN(partB);

        if (isNumericA && isNumericB) {
          const numA = Number(partA);
          const numB = Number(partB);
          if (numA !== numB)
            return direction === "ascending" ? numA - numB : numB - numA;
        } else if (isNumericA || isNumericB) {
          return isNumericA ? -1 : 1;
        } else {
          const comparison = partA.localeCompare(partB);
          if (comparison !== 0)
            return direction === "ascending" ? comparison : -comparison;
        }
      }

      return 0;
    });
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  console.log("filteredData", filteredData);

  // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);
  console.log('currentData', currentData);
  

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  const formatDate = (date) => {
    if (!date) return "-"; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
        "DD-MMM-YYYY",
        "DD-MM-YY",
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const [dropDownValue, setDropdownValue] = useState({});

  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  const tdRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tdRef.current && !tdRef.current.contains(event.target)) {
        setEditingIndex(null); // Reset on outside click
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingIndex]);


const transformDataForExport = (data) => {
  // First create a mapping of column names to their display text
  const columnHeaders = {};
  Object.keys(columns).forEach(columnName => {
    columnHeaders[columnName] = columns[columnName].text;
  });

  return data.map(item => {
    const transformedItem = {};
    
    // Convert all select columns to their display labels
    Object.keys(columns).forEach(columnName => {
      const columnConfig = columns[columnName];
      
      if (columnConfig.type === "Select" && columnConfig.option) {
        const foundOption = columnConfig.option.find(
          o => o.value === Number(item[columnName])
        );
        
        if (foundOption) {
          transformedItem[columnHeaders[columnName]] = foundOption.label;
        } else {
          transformedItem[columnHeaders[columnName]] = "Select";
        }
      } else {
        transformedItem[columnHeaders[columnName]] = item[columnName] || "";
      }
    });

    // Add the additional confirmation fields with custom labels
    if (item.IsConfirmed) {
      transformedItem["Approved"] = item.IsConfirmed;
    }
    if (item.ConfirmedDate) {
      transformedItem["Approve Date"] = formatDate(item.ConfirmedDate);
    }
    if (item.ConfirmedBy) {
      transformedItem["Approved By"] = item.ConfirmedBy;
    }
    
    return transformedItem;
  });
};

  return (
    <div className="container-fluid ">
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <div className="me-1">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <AttendanceBookStatementFilter
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleGetData={handleGetData}
                  handleReset={handleReset}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
          >
            <div className="me-1">
              <ExportToExcel
                 data={transformDataForExport(currentData)}
                filename={`${ExcelName}.csv`}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
          >
                <div className="btn-group me-2" style={{ position: "relative", zIndex: 100 }}>
                 <button
                   type="button"
                   className="dropdown-toggle skill-button"
                   data-bs-toggle="dropdown"
                   aria-expanded="false"
                   id="excel-btn"
                 >
                   <i className="bi bi-list"></i>
                 </button>
                 <ul 
                   className="dropdown-menu p-2" 
                   style={{ 
                     zIndex: 1000,
                     overscrollBehavior: 'contain', // Prevents scroll bleed
                     position: 'absolute',
                     inset: 'auto auto 0px 0px', // Adjust positioning if needed
                     maxHeight: '300px',
                     overflowY: 'auto'
                   }}
                 >
                   <div className="row">
                     <Form.Group style={{ width: '250px' }}>
                       {Object.keys(visibleColumns).map((columnName) => (
                         <Form.Check
                           key={columnName}
                           type="checkbox"
                           id={`checkbox-${columnName}`}
                           label={columnName}
                           checked={visibleColumns[columnName]}
                           onChange={() => toggleColumn(columnName)}
                         />
                       ))}
                     </Form.Group>
                   </div>
                 </ul>
               </div>
          </OverlayTrigger>
          {isAddNewBtnRequired && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-top">Save</Tooltip>}
            >
              <button id="Add-btn" onClick={handleAddNew}>
                <i className="fa fa-plus"></i> Save
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>

      <div className=" ">
        <div className="table-responsive  mb-2">
          <Table striped bordered hover rounded>
            <thead id="thcolor" className="text-center">
              <tr>
                {isCheckBoxRequired && (
                  <th style={{ width: "25px" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAllChecked}
                      onChange={(e) => handleSelectAllChange(e)}
                    />
                  </th>
                )}
                {isSrNoRequired && <th>Sr. No.</th>}
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn = /\b(date|on bench since  )\b/i.test(
                    columns[columnName].text
                  );

                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;
                  const isSelectColumn = columns[columnName].type === "Select";
                  const isTextColumn = columns[columnName].type === "Text";
                  const isButtonColumn = columns[columnName].type === "button";
                  const isModalColumn = columns[columnName].type === "Modal";
                  const isImageColumn = columns[columnName].type === "Image";
                  const isLinkColumn = columns[columnName].type === "Link";
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] && (
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          width: columns[columnName].width || "150px",
                        }}
                        key={columnName}
                        onClick={
                          isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon)
                            ? () => handleSort(columnName)
                            : undefined
                        }
                      >
                        {columns[columnName].text}
                        {isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon) && (
                            <span className="ms-1">
                              {sortConfig.key === columnName ? (
                                sortConfig.direction === "ascending" ? (
                                  <i className="bi bi-arrow-up"></i>
                                ) : (
                                  <i className="bi bi-arrow-down"></i>
                                )
                              ) : (
                                <i className="bi bi-arrow-down"></i>
                              )}
                            </span>
                          )}
                      </th>
                    )
                  );
                })}
                {isActionRequired && <th>Action</th>}
              </tr>
            </thead>
            {isRequiredStatus ? (
              isApiStatus === 200 && currentData?.length != 0 ? (
                <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    {isCheckBoxRequired && (
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={!!selectedResource?.find((o) => o.LineNo === item.LineNo)}
                          onChange={(e) => handleCheckboxChange(e, item.LineNo, item)}
                        />
                      </td>
                    )}
                    {isSrNoRequired && <td className="text-center">{index + 1}</td>}
                    {Object.keys(columns).map((columnName) => {
                      const columnConfig = columns[columnName];
                      const columnAlignment = columnConfig.align || "left";
                      const isSelectColumn = columnConfig.type === "Select";
                      const isTextColumn = columnConfig.type === "Text";
                      const isEditing = editingIndex?.row === index && editingIndex?.column === columnName;
                  const isDateColumn = /\b(date|on bench since  )\b/i.test(
                    columns[columnName].text
                  );
                      return (
                        visibleColumns[columnName] && (
                          <td
                            key={columnName}
                            className={`text-${columnAlignment} text-truncate`}
                            onClick={() => {
                              if (isSelectColumn || isTextColumn) {
                                setEditingIndex({ row: index, column: columnName });
                              }
                            }}
                            style={{
                              color: columnConfig.option?.find(o => o.value === Number(item[columnName]))?.color || "inherit",
                              cursor: "default",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              minWidth: columnConfig.width || "auto",
                              padding: isTextColumn && isEditing ? "0" : undefined,
                              position: isTextColumn && isEditing ? "relative" : "static"
                            }}
                          >
                            { isTextColumn ? (
                              isEditing ? (
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={item[columnName] || ""}
                                  onChange={(e) => handleTextChange(e, item, columnName)}
                                  autoFocus
                                  onBlur={() => setEditingIndex(null)}
                                  style={{ 
                                    width: "100%",
                                    minWidth: "100px",
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    height: "100%",
                                    border: "1px solid #ced4da",
                                    borderRadius: "0.25rem"
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              ) : (
                                <div 
                                  style={{
                                    width: "100%",
                                    minHeight: "100%",
                                    padding: "0.375rem 0.75rem"
                                  }}
                                >
                                  {item[columnName]}
                                </div>
                              )
                            ) : isSelectColumn ? (
                              columnConfig.option?.find(o => o.value === Number(item[columnName]))?.label || "Select"  // Changed "Select" to "Absent"
                            ) : isDateColumn ? (
                              formatDate(item[columnName])): (
                              item[columnName] || "Select"  // Added fallback for null values
                            )}
                          </td>
                        )
                      );
                    })}
                  </tr>
                ))}
              </tbody>
              ) : isApiStatus === 200 && currentData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              ) : isApiStatus === undefined  ? (
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0) +
                        (isSrNoRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <div>
                        <p>
                          <FaSpinner class="spinner" />
                          <br />
                          Loading
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                // isApiStatus !== 200 && currentData?.length === 0
                <tbody>
                  <tr>
                    <td
                      colSpan={
                        Object.keys(columns).length +
                        (isCheckBoxRequired ? 1 : 0) +
                        (isActionRequired ? 1 : 0)
                      }
                      className="text-center"
                    >
                      <p>No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              )
            ) :null}
          </Table>
        </div>
        {/* {filteredData.length > itemsPerPage && ( */}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={filteredData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default AttendanceBookStatementComponent;
